export const API_BASE = '';
export const USER_POOL_ID = 'us-east-1_UdFwcdv5K';
export const USER_POOL_CLIENT_ID = 'c24he9klpinavvp27bmj39qlc';
export const COGNITO_REGION = 'us-east-1';
export const DEMO_CLIENT_ID = 'leadsirl';
